import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app";
import "./styles.css";
import "./styles/design-tokens.css";
import "./styles/base.css";
import "./styles/pages.css";
import "./styles/editor.css";
import "./styles/overlays.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
